export const noticesData = [
  { id: 1, title: "Class Routine", date: "2022-08-28" },
  {
    id: 2,
    title: "Notice for admission in Ph.D. program for the academic year [...]",
    date: "2022-08-28",
  },
  { id: 3, title: "Class Routine-2022", date: "2022-03-02" },
  {
    id: 4,
    title: "Introductory Class Schedule for MSc",
    date: "2022-03-02",
  },
];
